import { createFileRoute } from '@tanstack/react-router'

import { MerchantWeeklyTiersScreen } from './-components/merchant-weekly-tiers-screen.tsx'

export const Route = createFileRoute(
  '/business-performance/merchant-weekly-tiers'
)({
  component: MerchantWeeklyTiersScreen
})
